module.exports = __webpack_public_path__ + "img/red-desert-decal-04.47894878.png";